import React from 'react';
import { withStyles } from '@material-ui/core';
import { TableAppHead, TableAppRow, TableAppCell } from 'components/IterioApp/components/TableApp';
import { usersConfig } from '../Users.config';

const styles = {
  th: {
    top: 0,
    zIndex: 1,
    position: 'sticky',
    background: '#E8E8EF',
  },
};

const UserTableHeader = ({ classes }) => {
  return (
    <TableAppHead>
      <TableAppRow type="headerRow">
        {usersConfig.map(header => {
          return (
            <TableAppCell
              key={header.name}
              style={{ width: header.width }}
              type="th"
              className={classes.th}
            >
              {header.label}
            </TableAppCell>
          );
        })}
      </TableAppRow>
    </TableAppHead>
  );
};

export default withStyles(styles)(UserTableHeader);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/UserTableHeader/UserTableHeader.js